import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { isObject } from 'ramda-extension';
import { useDispatch, useSelector } from 'react-redux';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';

import { Floating } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import SubmitFormDialog from 'components/atoms/GefMui/SubmitFormDialog/SubmitFormDialog';
import { EDIT_GUARANTOR_FORM_NAME } from 'features/views/campaignSettings/guarantors/form';
import guarantorsEdit from 'features/views/guarantorsEdit';
import { RADIO_OPTIONS_IDS } from 'features/views/guarantorsEdit/constants';
import { equalOrThreeDashes } from 'utils/equalOrThreeDashes';

import ActionButtons from './components/ActionButtons';
import Filter from './components/Filter';
import GuarantorsOfRegion from './components/GuarantorsOfRegion';
import GuarantorsTable from './components/GuarantorsTable';

export const EditGuarantorModalBody = ({ region, channelId, campaignId }) => {
	const dispatch = useDispatch();
	const formData = useFormData();
	const formIsInitiated = isObject(formData);
	const radio = useSelector(guarantorsEdit.selectors.getRadio);

	useEffect(() => {
		if (formIsInitiated) {
			dispatch(guarantorsEdit.actions.setGuarantorsOfRegion(region.guarantors));
			dispatch(guarantorsEdit.actions.setInitialState(channelId, region.id));
		}
	}, [dispatch, formIsInitiated, channelId, region]);

	useEffect(
		() => () => {
			dispatch(guarantorsEdit.actions.guarantorsEditHardReset());
		},
		[dispatch],
	);

	return (
		<Stack spacing={3}>
			<Floating>
				<SubmitFormDialog pageName={EDIT_GUARANTOR_FORM_NAME} />
			</Floating>
			<SectionHeader text={equalOrThreeDashes(region.name)} />
			<GuarantorsOfRegion />
			<Filter />
			{radio === RADIO_OPTIONS_IDS.outOrganizeStructure && <GuarantorsTable />}
			<ActionButtons region={region} channelId={channelId} campaignId={campaignId} />
		</Stack>
	);
};

EditGuarantorModalBody.propTypes = {
	campaignId: PropTypes.string,
	channelId: PropTypes.string,
	region: PropTypes.string,
};

export default EditGuarantorModalBody;
